var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxalisSiteWebBoutonsFlecheBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    style: {
      enableBackground: "new 0 0 51 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#914E72;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,47.6l19.7-18.5l-2.6-2.6c-2.7,3.9-7.4,9.4-11,13.8c-2.2,2.6-4.2,4.6-5.5,6v-6c0-13.8,0.9-24.6,2.2-34.2 h-5.4c1.4,9.4,2.2,20.4,2.2,34.2v6c-1.3-1.4-3.1-3.4-5.4-6c-3.7-4.2-8.5-9.8-11.2-13.8l-2.6,2.6L25.5,47.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxalisSiteWebBoutonsFlecheBlanc);
export default __webpack_public_path__ + "static/media/OXALIS_site_web_boutons_fleche_blanc.322019c75890b3fcc75c6e3788ab1d4f.svg";
export { ForwardRef as ReactComponent };